// The admin root Vue instance's own data defaults (resources/js/admin/app.js).
//
// VModalLink renders AJAX-loaded admin pages (e.g. the property edit form) in a separate Vue
// instance, and those templates bind to these the same way the full page does - the property
// Save button's :disabled="formSaving" threw "formSaving is not defined" in the modal without it.
// A function, so the root and every modal get their own fresh copy: never the root's live data,
// which also holds the host page's state.
export function adminRootDataDefaults() {
  return {
    name: 'AtHome',
    shouldReloadOnCloseModal: false,
    // True while saveWithFacilities() runs; Save buttons bind :disabled to it.
    formSaving: false,
    availableLocales: [
      {
        code: 'en',
        name: 'English'
      },
      {
        code: 'nl',
        name: 'Dutch'
      }
    ],
  };
}
